import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "services/api";
import Breadcrumbs from "components/common/Breadcrumbs";
import ProgrammeSelector from "components/common/ProgrammeSelector";
import PageCard from "components/pages/PageCard"; // Nouvelle carte pour afficher les pages
import styles from "./ProgrammePage.module.css";
import CardSpectacle from "components/common/CardSpectacle";
import archiveStyle from "styles/modules/Archives.module.css";
import Spinner from "components/common/Spinner";
import LoadMoreButton from "components/common/LoadMoreButton";
import { Helmet } from "react-helmet";

const ProgrammePage = () => {
  const [loading, setLoading] = useState(true);
  const [spectacles, setSpectacles] = useState([]);
  const [displayCount, setDisplayCount] = useState(8); // Nombre initial de spectacles affichés

  useEffect(() => {
    const fetchProgrammeData = async () => {
      try {
        const response = await api.get(`/spectacles`);
        const spectacles = response.data;
        setSpectacles(spectacles);
      } catch (error) {
        console.error("Erreur lors de la récupération des données des spectacles pour le programme :", error);
      } finally {
        setLoading(false);
      }
    };
    fetchProgrammeData();
  }, []);

  console.log("spectacles", spectacles);

  // Calculer les spectacles à afficher
  const displayedSpectacles = spectacles.slice(0, displayCount);
  const hasMore = spectacles.length > displayCount;

  // Charger plus de spectacles
  const loadMore = () => {
    setDisplayCount(prevCount => prevCount + 6);
  };

  if (loading) return <div className="page-content section-no-padding">
    <section className={`global-section global-section-title ${styles.section}`} style={{ minHeight: '100vh', paddingTop: 200 }}>
      <Spinner />
    </section>
  </div>;
  if (!spectacles) return <div>Programme non trouvé.</div>;

  return (
    <>
      <Helmet>
        <title>Le Programme - Pharos</title>
        <meta name="description" content="Découvrez le programme des spectacles à venir sur Pharos. Explorez les événements, les dates et les détails des spectacles." />
        <meta property="og:title" content="Le Programme - Pharos" />
        <meta property="og:description" content="Découvrez le programme des spectacles à venir sur Pharos. Explorez les événements, les dates et les détails des spectacles." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className="page-content section-no-padding">
        <section className={`global-section global-section-title ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            <div className={`path-header ${archiveStyle.header}`}>
              <h1 className="h2">Le Programme</h1>
              {/* Fil d'Ariane */}
              <Breadcrumbs pageType="isProgramme" element={{ title: "Le Programme" }} />
            </div>
          </div>
        </section>
        <section className={`global-section ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            <ProgrammeSelector activeTab={`all`} />
          </div>
          <div className={`global-container ${styles.content}`}>
            <h2 className="sr-only">Liste des concerts et spectacles</h2>
            {/* Liste des spectacles ou message d'absence */}
            {spectacles && spectacles.length > 0 ? (
              <>
                <ul className={`${styles.spectacleList}`}>
                  {displayedSpectacles.map((spectacle) => (
                    <CardSpectacle
                      key={spectacle.id}
                      name={spectacle.name}
                      plage_date={spectacle.plage_date}
                      description={spectacle.shortDescription}
                      poster={spectacle.poster}
                      typeShow={spectacle.typeShow}
                      link={`/programme/${spectacle.typeShow.code}/${spectacle.slug}`}
                    />
                  ))}
                </ul>
                
                {/* Bouton Voir plus */}
                {hasMore && (
                  <LoadMoreButton onClick={loadMore} />
                )}
              </>
            ) : (
              <p>Aucun spectacle trouvé.</p>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default ProgrammePage;
